//竖直方向旋转
async function verticalRotate(resultVerticalObj, degree) {
	function handleVerticalDegree(rect = []) {
		if (!rect.length) return []
		rect.forEach(resp => {
			if (!resp.top) resp.top = 0
			if (!resp.initY) resp.initY = resp.y
			resp.top = resp.top + Math.tan(degree * (Math.PI / 180)) * resp.x
			resp.y = resp.top + resp.initY
		})
		return rect
	}
	return {
		box: handleVerticalDegree(resultVerticalObj.box),
		title: handleVerticalDegree(resultVerticalObj.title)
	}
}
// 水平方向 旋转
async function horizontalRotate(resultHorizontalObj, degree) {
	function handleHorizontalDegree(rect = []) {
		if (!rect.length) return []
		rect.forEach(resp => {
			if (!resp.left) resp.left = 0
			if (!resp.initX) resp.initX = resp.x
			resp.left = resp.left + Math.atan(degree * (Math.PI / 180)) * resp.y
			resp.x = resp.left + resp.initX
		})
		return rect
	}
	return {
		box: handleHorizontalDegree(resultHorizontalObj.box),
		title: handleHorizontalDegree(resultHorizontalObj.title)
	}
}
// 格式化考号
function formatExamNoList(list, index) {
	const box = JSON.parse(list[index].appendInfo).box
	let resObj = {}
	box.forEach(res => {
		if (!resObj[res.v]) resObj[res.v] = []
		resObj[res.v].push(res)
	})
	return resObj
}

export { verticalRotate, horizontalRotate, formatExamNoList }
